import { useNavigate, useParams } from "react-router-dom";
import CampaignUI from "../components/campaignUI/CampaignUI";
import { FaLongArrowAltLeft } from "react-icons/fa";
import { AppLayout } from "../layout/AppLayout";
import { motion } from "framer-motion";
import { useContext, useEffect, useRef } from "react";
import { UserContext } from "../components/context/UseContext";
import { Loader } from "../components/loader/Loader";
import { useGetCampaignById } from "../api/campaigns/getCampaignById";
import clsx from "clsx";

function Campaigns() {
  const { token } = useContext(UserContext);
  const navigate = useNavigate();
  const params = useParams();
  const hasFetched = useRef(false);

  const { getCampaignById, campaign, loading } = useGetCampaignById();

  useEffect(() => {
    if (!hasFetched.current) {
      hasFetched.current = true;
      getCampaignById(token, params?.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AppLayout bg={"!bg-[#F8F8F8]"}>
      {loading ? (
        <div className="h-[70dvh] flex items-center justify-center">
          <Loader type="spinningBubbles" color="#0ca6ed" />
        </div>
      ) : (
        <div className="relative">
          <motion.div
            className={clsx(
              !campaign?.image_url && "main_gradient",
              "relative rounded-b-[25px]",
            )}
          >
            <img
              className="w-full mb-8 object-cover h-[300px] rounded-b-[25px]"
              src={campaign?.image_url ?? "/image/celebrate.png"}
              alt="banner"
              loading="lazy"
            />
            <h3 className="text-2xl font-semibold absolute bottom-10 w-full transform -translate-x-1/2 left-1/2 text-center uppercase text-white">
              {campaign?.title}
            </h3>
            <p
              onClick={() => navigate("/home")}
              className="absolute cursor-pointer top-5 left-8 flex items-center gap-2 font-medium text-white"
            >
              <FaLongArrowAltLeft className="text-lg" /> Back
            </p>
          </motion.div>
          <div className="container pb-12">
            <CampaignUI
              campaignGames={campaign}
              description={campaign?.game?.description}
            />
          </div>
        </div>
      )}
    </AppLayout>
  );
}

export default Campaigns;
